export const PROMO_CODE_APPLIED = {
  PromoEffectWaiveDeliveryFee: "Free Delivery.",
  PromoEffectWaiveLateFee: "No late fee.",
  PromoEffectFlatAmtOff: "${amount} OFF Gear.",
  PromoEffectPercentOff: "{amount}% OFF Gear.",
  CookiePrefix: "appliedPromoCode",
  Success: "Coupon applied!",
  Error:
    "An error occurred while applying the promo code. Please try again later.",
};

export const PROMO_CODE_REMOVED = {
  Success: "Promo code removed successfully!",
  Error:
    "An error occurred while removing the promo code. Please try again later.",
};

export const PROMO_CODE_ERROR = "Invalid promo code. Please try again.";

export const FEATURED_PROMOTION = {
  BundlePercentOff: {
    NAME: "Package Bundle Discount",
    BANNER: {
      TITLE: "Bundle & Save!",
      SUBTITLE:
        "Add a package to your cart and unlock {discount}% off additional gear automatically!",
    },
    TERMS:
      "Discount applied to items of equal or lesser value. Cannot be combined with other coupons or offers. Savings will be automatically shown at checkout.",
  },
};

export const INLINE_PROMO_THRESHOLD = "inlinePromoThreshold";
